import axios from "axios";

export const apiUrl = (path = "") => {
    const base = String(axios.defaults.baseURL || "").replace(/\/+$/, "");
    const p = String(path || "").replace(/^\/+/, "");
    return p ? `${base}/${p}` : base;
};

export default apiUrl;